<div class="menu-shell p-2 p-lg-2">
  <div class="menu-panel">
    <div class="menu-header">
      <div class="d-flex align-items-center gap-2">
        <span class="title-icon">
          <lucide-icon [img]="ClipboardListIcon" [size]="16"></lucide-icon>
        </span>
        <h1 class="m-0">Menu</h1>
      </div>
      <button class="btn btn-primary add-btn" type="button" (click)="openAdd()">
        <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon>
        <span>ADD</span>
      </button>
    </div>

    <div class="menu-toolbar">
      <div class="search-wrap">
        <input class="form-control" placeholder="Search Menu" [value]="search()" (input)="onSearch(($any($event.target).value || '').toString())" />
        <lucide-icon [img]="SearchIcon" [size]="16" class="search-icon"></lucide-icon>
      </div>
    </div>

    <div class="table-wrap">
      <div class="table-responsive">
        <table class="table mb-0 menu-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Menu Name</th>
              <th>User Type</th>
              <th>Url</th>
              <th>Priority</th>
              <th>Parent</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            @if (filteredRows().length === 0) {
              <tr>
                <td colspan="7" class="text-center py-5 text-muted">No menu records found.</td>
              </tr>
            }
            @for (row of filteredRows(); track row.id; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td>
                  <span class="name-cell" [style.padding-left.px]="rowLevel(row) * 16">{{ row.menu_name }}</span>
                </td>
                <td>{{ row.user_type }}</td>
                <td>{{ row.menu_url }}</td>
                <td>{{ row.menu_priority }}</td>
                <td>{{ parentLabel(row) }}</td>
                <td>
                  <div class="action-list">
                    <button class="action-btn edit" type="button" title="Edit" (click)="openEdit(row)">
                      <lucide-icon [img]="PencilIcon" [size]="14"></lucide-icon>
                    </button>
                    <button class="action-btn delete" type="button" title="Delete" (click)="remove(row)">
                      <lucide-icon [img]="Trash2Icon" [size]="14"></lucide-icon>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

@if (showForm()) {
  <div class="menu-modal-backdrop">
    <div class="menu-modal">
      <div class="menu-modal-header">
        <h2 class="m-0">{{ editingId() ? 'Edit Menu' : 'Add Menu' }}</h2>
        <button type="button" class="close-btn" (click)="closeForm()">x</button>
      </div>

      <div class="menu-modal-body">
        <div class="form-grid">
          <div class="field-wrap">
            <label>Menu Name <span>*</span></label>
            <input class="form-control" placeholder="Menu name" [value]="form().menuName" (input)="setField('menuName', ($any($event.target).value || '').toString())" />
          </div>
          <div class="field-wrap">
            <label>Menu url <span>*</span></label>
            <input class="form-control" placeholder="Menu url" [value]="form().menuUrl" (input)="setField('menuUrl', ($any($event.target).value || '').toString())" />
          </div>

          <div class="field-wrap">
            <label>User Type <span>*</span></label>
            <select class="form-select" [value]="form().userType" (change)="setField('userType', ($any($event.target).value || '').toString())">
              <option value="">Select User Type</option>
              <option value="STAFF">STAFF</option>
              <option value="VENDOR">VENDOR</option>
              <option value="BOTH">BOTH</option>
            </select>
          </div>
          <div class="field-wrap">
            <label>Menu priority <span>*</span></label>
            <input
              type="number"
              class="form-control"
              placeholder="Menu priority"
              [value]="form().menuPriority"
              (input)="setField('menuPriority', +(($any($event.target).value || '0').toString()))"
            />
          </div>

          <div class="field-wrap">
            <label>Menu List <span>*</span></label>
            <input class="form-control" placeholder="Menu List" [value]="form().menuList" (input)="setField('menuList', ($any($event.target).value || '').toString())" />
          </div>
          <div class="field-wrap">
            <label>Parent Menu</label>
            <select class="form-select" [value]="form().parentId" (change)="setField('parentId', ($any($event.target).value || '').toString())">
              <option value="">No Parent (Root)</option>
              @for (option of parentOptions(); track option.id) {
                <option [value]="option.id">{{ option.label }}</option>
              }
            </select>
          </div>

          <div class="field-wrap">
            <label>Menu alias</label>
            <input class="form-control" placeholder="Menu alias" [value]="form().menuAlias" (input)="setField('menuAlias', ($any($event.target).value || '').toString())" />
          </div>

          <div class="field-wrap">
            <label>Menu icon</label>
            <input class="form-control" placeholder="Menu icon" [value]="form().menuIcon" (input)="setField('menuIcon', ($any($event.target).value || '').toString())" />
          </div>
          <div class="field-wrap">
            <label>Send Image</label>
            <input class="form-control" placeholder="Send image" [value]="form().sendImage" (input)="setField('sendImage', ($any($event.target).value || '').toString())" />
          </div>
        </div>

        <div class="toggle-row">
          <label class="checkbox-wrap">
            <input type="checkbox" [checked]="form().isDefault" (change)="setField('isDefault', !!$any($event.target).checked)" />
            <span>Default</span>
          </label>
          <label class="checkbox-wrap">
            <input type="checkbox" [checked]="form().isShow" (change)="setField('isShow', !!$any($event.target).checked)" />
            <span>Show</span>
          </label>
        </div>

        @if (formError()) {
          <div class="text-danger small mt-2">{{ formError() }}</div>
        }
      </div>

      <div class="menu-modal-footer">
        <button class="btn btn-primary" type="button" [disabled]="submitting()" (click)="save()">
          {{ submitting() ? 'SAVING...' : 'SAVE' }}
        </button>
      </div>
    </div>
  </div>
}
